module.exports = __webpack_public_path__ + "img/notification-read.2496cf19.svg";